import "../../../chunk-D57E6H3M.mjs";

// src/components/composite/Conversations/Conversations.tsx
import { useEffect, useId, useLayoutEffect, useRef, useState } from "react";
import { MdChatBubbleOutline, MdChevronLeft, MdErrorOutline, MdRefresh } from "react-icons/md";

// ../channel-branding/dist/brands.js
var CHANNEL_BRANDS = {
  website: {
    label: "Website",
    icon: "mdi:message-text",
    tint: "linear-gradient(135deg, rgba(255, 255, 255, 0.3), transparent 65%), #efa747"
  },
  instagram: {
    label: "Instagram",
    icon: "mdi:instagram",
    tint: "linear-gradient(45deg, #feda75 0%, #fa7e1e 25%, #d62976 50%, #962fbf 75%, #4f5bd5 100%)"
  },
  messenger: {
    label: "Messenger",
    icon: "mdi:facebook-messenger",
    tint: "linear-gradient(135deg, #00b2ff, #006aff)"
  },
  whatsapp: {
    label: "WhatsApp",
    icon: "mdi:whatsapp",
    tint: "linear-gradient(135deg, #65ee99, #0eb75d)"
  },
  sms: {
    label: "SMS",
    icon: "mdi:message-processing",
    tint: "linear-gradient(135deg, #4ade80, #16a34a)"
  },
  email: {
    label: "Email",
    icon: "mdi:email",
    tint: "linear-gradient(135deg, #78c5ff, #2385ec)"
  },
  tiktok: {
    label: "TikTok",
    icon: "logos:tiktok-icon",
    tint: "linear-gradient(135deg, #303030, #010101)"
  },
  shopify: {
    label: "Shopify",
    icon: "mdi:shopify",
    tint: "#95bf47"
  }
};
function isChannelKey(channel) {
  return Object.hasOwn(CHANNEL_BRANDS, channel);
}
function getChannelBrand(channel) {
  return isChannelKey(channel) ? CHANNEL_BRANDS[channel] : void 0;
}
var FALLBACK_CHANNEL_ICON = "ic:outline-forum";
function channelLabel(channel) {
  return getChannelBrand(channel)?.label ?? channel;
}

// ../channel-branding/dist/ChannelBrandIcon.js
import { jsx as _jsx } from "react/jsx-runtime";
import { forwardRef } from "react";
import { Icon } from "@iconify/react";

// ../channel-branding/dist/icon-data.js
var iconData = {
  "mdi:message-text": {
    width: 24,
    height: 24,
    body: '<path fill="currentColor" d="M20 2H4a2 2 0 0 0-2 2v18l4-4h14a2 2 0 0 0 2-2V4a2 2 0 0 0-2-2M6 9h12v2H6m8 3H6v-2h8m4-4H6V6h12"/>'
  },
  "mdi:instagram": {
    width: 24,
    height: 24,
    body: '<path fill="currentColor" d="M7.8 2h8.4C19.4 2 22 4.6 22 7.8v8.4a5.8 5.8 0 0 1-5.8 5.8H7.8C4.6 22 2 19.4 2 16.2V7.8A5.8 5.8 0 0 1 7.8 2m-.2 2A3.6 3.6 0 0 0 4 7.6v8.8C4 18.39 5.61 20 7.6 20h8.8a3.6 3.6 0 0 0 3.6-3.6V7.6C20 5.61 18.39 4 16.4 4zm9.65 1.5a1.25 1.25 0 0 1 1.25 1.25A1.25 1.25 0 0 1 17.25 8A1.25 1.25 0 0 1 16 6.75a1.25 1.25 0 0 1 1.25-1.25M12 7a5 5 0 0 1 5 5a5 5 0 0 1-5 5a5 5 0 0 1-5-5a5 5 0 0 1 5-5m0 2a3 3 0 0 0-3 3a3 3 0 0 0 3 3a3 3 0 0 0 3-3a3 3 0 0 0-3-3"/>'
  },
  "mdi:facebook-messenger": {
    width: 24,
    height: 24,
    body: '<path fill="currentColor" d="M12 2C6.36 2 2 6.13 2 11.7c0 2.91 1.19 5.44 3.14 7.17c.16.13.26.35.27.57l.05 1.78c.04.57.61.94 1.13.71l1.98-.87c.17-.06.36-.09.53-.06c.9.27 1.9.4 2.9.4c5.64 0 10-4.13 10-9.7S17.64 2 12 2m6 7.46l-2.93 4.67c-.47.73-1.47.92-2.17.37l-2.34-1.73a.6.6 0 0 0-.72 0l-3.16 2.4c-.42.33-.97-.17-.68-.63l2.93-4.67c.47-.73 1.47-.92 2.17-.4l2.34 1.76a.6.6 0 0 0 .72 0l3.16-2.4c.42-.33.97.17.68.63"/>'
  },
  "mdi:whatsapp": {
    width: 24,
    height: 24,
    body: '<path fill="currentColor" d="M12.04 2c-5.46 0-9.91 4.45-9.91 9.91c0 1.75.46 3.45 1.32 4.95L2.05 22l5.25-1.38c1.45.79 3.08 1.21 4.74 1.21c5.46 0 9.91-4.45 9.91-9.91c0-2.65-1.03-5.14-2.9-7.01A9.82 9.82 0 0 0 12.04 2m.01 1.67c2.2 0 4.26.86 5.82 2.42a8.23 8.23 0 0 1 2.41 5.83c0 4.54-3.7 8.23-8.24 8.23c-1.48 0-2.93-.39-4.19-1.15l-.3-.17l-3.12.82l.83-3.04l-.2-.32a8.2 8.2 0 0 1-1.26-4.38c.01-4.54 3.7-8.24 8.25-8.24M8.53 7.33c-.16 0-.43.06-.66.31c-.22.25-.87.86-.87 2.07c0 1.22.89 2.39 1 2.56c.14.17 1.76 2.67 4.25 3.73c.59.27 1.05.42 1.41.53c.59.19 1.13.16 1.56.1c.48-.07 1.46-.6 1.67-1.18s.21-1.07.15-1.18c-.07-.1-.23-.16-.48-.27c-.25-.14-1.47-.74-1.69-.82c-.23-.08-.37-.12-.56.12c-.16.25-.64.81-.78.97c-.15.17-.29.19-.53.07c-.26-.13-1.06-.39-2-1.23c-.74-.66-1.23-1.47-1.38-1.72c-.12-.24-.01-.39.11-.5c.11-.11.27-.29.37-.44c.13-.14.17-.25.25-.41c.08-.17.04-.31-.02-.43c-.06-.11-.56-1.35-.77-1.84c-.2-.48-.4-.42-.56-.43c-.14 0-.3-.01-.47-.01"/>'
  },
  "mdi:message-processing": {
    width: 24,
    height: 24,
    body: '<path fill="currentColor" d="M17 11h-2V9h2m-4 2h-2V9h2m-4 2H7V9h2m11-7H4a2 2 0 0 0-2 2v18l4-4h14a2 2 0 0 0 2-2V4a2 2 0 0 0-2-2"/>'
  },
  "mdi:email": {
    width: 24,
    height: 24,
    body: '<path fill="currentColor" d="m20 8l-8 5l-8-5V6l8 5l8-5m0-2H4c-1.11 0-2 .89-2 2v12a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2V6a2 2 0 0 0-2-2"/>'
  },
  "mdi:shopify": {
    width: 24,
    height: 24,
    body: '<path fill="currentColor" d="M18.61 5.89c-.01-.1-.11-.16-.17-.16c-.07-.01-1.61-.12-1.61-.12s-1.07-1.06-1.18-1.18c-.12-.12-.35-.08-.44-.06c-.01 0-.21.07-.6.18c-.36-1.05-.99-1.97-2.18-1.97c-.32-.4-.71-.58-1.05-.58c-2.58 0-3.81 3.22-4.2 4.86l-1.81.56c-.55.18-.57.2-.64.72c-.06.4-1.52 11.72-1.52 11.72L14.61 22l6.18-1.34S18.62 6 18.61 5.89M14 4.76c-.31.09-.63.19-1 .3v-.21c0-.64-.07-1.15-.21-1.56c.56.07.94.71 1.21 1.47m-1.92-1.34c.16.4.26.97.26 1.74v.11c-.63.19-1.31.41-1.99.62c.38-1.49 1.1-2.2 1.73-2.47m-.77-.73c.11 0 .22.04.33.11c-.83.39-1.71 1.37-2.09 3.32c-.55.18-1.08.34-1.55.5c.42-1.5 1.46-3.93 3.31-3.93m1.19 6.46l-.74 2.27s-.67-.36-1.49-.36c-1.2 0-1.27.75-1.27.94c0 1.04 2.71 1.43 2.71 3.86c0 1.91-1.21 3.14-2.84 3.14c-1.96 0-2.96-1.22-2.96-1.22l.52-1.73s1.03.88 1.9.88c.57 0 .8-.43.8-.77c0-1.35-2.21-1.41-2.21-3.63c0-1.87 1.34-3.68 4.05-3.68c1.03 0 1.53.3 1.53.3m2.93-3.86l1.32 1.31l.96.08c.34 2.32 1.48 10.05 1.95 13.2l-5 1.09l.77-15.68z"/>'
  },
  "ic:outline-forum": {
    width: 24,
    height: 24,
    body: '<path fill="currentColor" d="M15 4v7H5.17L4 12.17V4zm1-2H3c-.55 0-1 .45-1 1v14l4-4h10c.55 0 1-.45 1-1V3c0-.55-.45-1-1-1m5 4h-2v9H6v2c0 .55.45 1 1 1h11l4 4V7c0-.55-.45-1-1-1"/>'
  },
  "logos:tiktok-icon": {
    width: 256,
    height: 290,
    body: '<path fill="#ff004f" d="M189.72 104.421c18.678 13.345 41.56 21.197 66.273 21.197v-47.53a67 67 0 0 1-13.918-1.456v37.413c-24.711 0-47.59-7.851-66.272-21.195v96.996c0 48.523-39.356 87.855-87.9 87.855c-18.113 0-34.949-5.473-48.934-14.86c15.962 16.313 38.222 26.432 62.848 26.432c48.548 0 87.905-39.332 87.905-87.857v-96.995zm17.17-47.952c-9.546-10.423-15.814-23.893-17.17-38.785v-6.113h-13.189c3.32 18.927 14.644 35.097 30.358 44.898M69.673 225.607a40 40 0 0 1-8.203-24.33c0-22.192 18.001-40.186 40.21-40.186a40.3 40.3 0 0 1 12.197 1.883v-48.593c-4.61-.631-9.262-.9-13.912-.801v37.822a40.3 40.3 0 0 0-12.203-1.882c-22.208 0-40.208 17.992-40.208 40.187c0 15.694 8.997 29.281 22.119 35.9"/><path d="M175.803 92.849c18.683 13.344 41.56 21.195 66.272 21.195V76.631c-13.794-2.937-26.005-10.141-35.186-20.162c-15.715-9.802-27.038-25.972-30.358-44.898h-34.643v189.843c-.079 22.132-18.049 40.052-40.21 40.052c-13.058 0-24.66-6.221-32.007-15.86c-13.12-6.618-22.118-20.206-22.118-35.898c0-22.193 18-40.187 40.208-40.187c4.255 0 8.356.662 12.203 1.882v-37.822c-47.692.985-86.047 39.933-86.047 87.834c0 23.912 9.551 45.589 25.053 61.428c13.985 9.385 30.82 14.86 48.934 14.86c48.545 0 87.9-39.335 87.9-87.857z"/><path fill="#00f2ea" d="M242.075 76.63V66.516a66.3 66.3 0 0 1-35.186-10.047a66.47 66.47 0 0 0 35.186 20.163M176.53 11.57a68 68 0 0 1-.728-5.457V0h-47.834v189.845c-.076 22.13-18.046 40.05-40.208 40.05a40.06 40.06 0 0 1-18.09-4.287c7.347 9.637 18.949 15.857 32.007 15.857c22.16 0 40.132-17.918 40.21-40.05V11.571zM99.966 113.58v-10.769a89 89 0 0 0-12.061-.818C39.355 101.993 0 141.327 0 189.845c0 30.419 15.467 57.227 38.971 72.996c-15.502-15.838-25.053-37.516-25.053-61.427c0-47.9 38.354-86.848 86.048-87.833"/>'
  }
};
var icon_data_default = iconData;

// ../channel-branding/dist/ChannelBrandIcon.js
var glyphs = icon_data_default;
var GLYPH_SCALE = { rounded: "77.083333%", circle: "62.5%" };
var ChannelBrandIcon = forwardRef(function ChannelBrandIcon2({ channel, size = 40, shape = "rounded", className, style, ...rest }, ref) {
  const brand = getChannelBrand(channel);
  const roundedRadius = brand ? "30%" : "var(--radius-lg, 10px)";
  const tileStyle = {
    display: "inline-flex",
    alignItems: "center",
    justifyContent: "center",
    flexShrink: 0,
    width: size,
    height: size,
    borderRadius: shape === "circle" ? "50%" : roundedRadius,
    background: brand?.tint ?? "var(--bs-lg-fill-3, var(--bs-bg-hover, color-mix(in srgb, currentColor 8%, transparent)))",
    color: brand ? "#fff" : "var(--bs-lg-ink, var(--bs-text-secondary, inherit))",
    ...style
  };
  return _jsx("span", { ref, className, style: tileStyle, "aria-hidden": "true", ...rest, children: _jsx(Icon, { icon: glyphs[brand?.icon ?? FALLBACK_CHANNEL_ICON], ssr: true, fill: "currentColor", width: GLYPH_SCALE[shape], height: GLYPH_SCALE[shape], style: { display: "block", flexShrink: 0 } }) });
});
ChannelBrandIcon.displayName = "ChannelBrandIcon";

// src/components/composite/Conversations/Conversations.tsx
import { useNow } from "../../../hooks/useNow.mjs";
import { formatTimestamp } from "../../../utils/formatTimestamp.mjs";
import { Badge, Button, EmptyState, EmptyStateActions, EmptyStateDescription, EmptyStateMedia, EmptyStateTitle, Select, SelectContent, SelectItem, SelectTrigger, SelectValue, Skeleton, Switch, TextField, Tooltip } from "../../primitive/index.mjs";
import { Pagination } from "../Pagination/index.mjs";
import { createComposerDraft } from "./composer-draft.mjs";
import ConversationComposer from "./ConversationComposer.mjs";
import { ConversationMessages } from "./ConversationMessages.mjs";
import { EmailThread } from "./EmailThread.mjs";
import { useConversationsTranslation } from "./use-conversations-translation.mjs";
import { conversationChannel, conversationKey, conversationName, matchesConversation, storeOrigin, tokenUsageText, totalTokenUsage } from "./utils.mjs";
import { Fragment, jsx, jsxs } from "react/jsx-runtime";
function AnchorLink({ href, children }) {
  return /* @__PURE__ */ jsx("a", { href, children });
}
var ROW_TITLE_WIDTHS = ["56%", "44%", "64%", "50%"];
var ROW_META_WIDTHS = ["72%", "60%", "80%", "66%"];
var hexColor = (color) => color && /^#[\da-f]{6}$/i.test(color) ? color : void 0;
var storeAccentStyle = (color) => ({ "--bs-conversations-store-color": color });
function Conversations({ groupedChatSessions = [], loading = false, error, onRetry, pagination, onFetchChatSessions, searchValue, onSearchValueChange, channels, channel = "all", onChannelChange, engagedOnly, onEngagedChange, highlightedSessionId, showTokenUsage = false, showSessionId = true, storeID, storeAvatarUrl, storeColor, customDomain, onDeleteSession, onToolClick, getUserHref, UserLink = AnchorLink, onSendChannelMessage, onResumeAi, onUploadChannelAttachment, className = "", filterSlot, renderSessionExtra }) {
  const { t, i18n } = useConversationsTranslation();
  const locale = i18n.resolvedLanguage || i18n.language;
  const now = useNow();
  const stamped = (value, time, phrase) => {
    const stamp = formatTimestamp(value, { now, locale, time, inline: !time });
    return stamp ? /* @__PURE__ */ jsx("time", { dateTime: stamp.dateTime, title: stamp.title, children: phrase(stamp.text) }) : phrase("\u2014");
  };
  const anonymous = { visitor: t("shared.chat.anonymous_visitor"), user: t("shared.chat.anonymous_user") };
  const genericChannelNames = { website: t("shared.chat.channel.website"), email: t("shared.chat.channel.email"), sms: t("shared.chat.channel.sms") };
  const channelName = (value) => genericChannelNames[value] ?? channelLabel(value);
  const tokens = (value) => t("shared.chat.token_usage.tokens", { count: value, value: value.toLocaleString(locale) });
  const engagedId = useId();
  const [localSearch, setLocalSearch] = useState("");
  const [selectedKey, setSelectedKey] = useState(null);
  const [threadOpen, setThreadOpen] = useState(false);
  const [drafts, setDrafts] = useState({});
  const listRef = useRef(null);
  const readerScrollRef = useRef(null);
  const backRef = useRef(null);
  const searchRef = useRef(null);
  const triggerRef = useRef(null);
  const sessionRefs = useRef(/* @__PURE__ */ new Map());
  const query = searchValue ?? localSearch;
  const groups = groupedChatSessions.filter((group) => matchesConversation(group, query, anonymous) && (channel === "all" || conversationChannel(group) === channel));
  const [lastShown, setLastShown] = useState(6);
  if (!loading && groups.length > 0 && groups.length !== lastShown) setLastShown(groups.length);
  const selected = groups.find((group) => conversationKey(group) === selectedKey);
  const key = selected ? conversationKey(selected) : null;
  const selectedChannel = selected ? conversationChannel(selected) : void 0;
  const capabilities = selected?.capabilities;
  const replyId = selected && "userIdentifier" in selected ? selected.replySessionId : void 0;
  const draftKey = JSON.stringify([storeID, key, replyId]);
  const canReply = Boolean(capabilities?.reply && replyId && onSendChannelMessage);
  const canDelete = !!onDeleteSession && capabilities?.deleteSession !== false;
  const showGroupSessionId = showSessionId && capabilities?.showSessionId !== false;
  const replySession = selected?.sessions.find((session) => session.id === replyId);
  const replyAddress = selected && "userIdentifier" in selected ? selected.replyAddress || void 0 : void 0;
  const userId = selected && !("visitorID" in selected) ? selected.userIdentifier : null;
  const name = selected ? conversationName(selected, anonymous) : "";
  const messageCount = selected?.sessions.reduce((count, session) => count + session.chatMessage.length, 0) ?? 0;
  const smsOptedOut = !!selected && "smsOptedOut" in selected && selected.smsOptedOut === true;
  const usage = selected && showTokenUsage ? totalTokenUsage(selected) : void 0;
  useEffect(() => {
    if (!highlightedSessionId) return;
    const match = groupedChatSessions.find((group) => group.sessions.some((session) => session.id.includes(highlightedSessionId)));
    if (match) {
      setSelectedKey(conversationKey(match));
      setThreadOpen(true);
    }
  }, [highlightedSessionId, groupedChatSessions]);
  useLayoutEffect(() => {
    if (threadOpen && selected && listRef.current && getComputedStyle(listRef.current).display === "none") backRef.current?.focus({ preventScroll: true });
    else if (!threadOpen && triggerRef.current?.isConnected) triggerRef.current.focus({ preventScroll: true });
  }, [threadOpen, key]);
  useLayoutEffect(() => {
    const scroll = readerScrollRef.current;
    if (!threadOpen || !key || !scroll) return;
    const sections = Array.from(sessionRefs.current.values());
    const highlighted = highlightedSessionId && sections.find((section) => section.dataset.sessionId?.includes(highlightedSessionId));
    const firstSession = scroll.querySelector(".bs-conversations__session");
    const expandedEmail = firstSession?.querySelector('.email-message:has([aria-expanded="true"])');
    const target = highlighted || expandedEmail || firstSession;
    const padding = Number.parseFloat(getComputedStyle(scroll).paddingTop) || 0;
    scroll.scrollTop = target ? Math.max(0, scroll.scrollTop + target.getBoundingClientRect().top - scroll.getBoundingClientRect().top - padding) : 0;
  }, [highlightedSessionId, key, threadOpen]);
  const search = (value) => {
    setLocalSearch(value);
    onSearchValueChange?.(value);
    setThreadOpen(false);
    triggerRef.current = null;
  };
  const filtered = query.trim() !== "" || channel !== "all";
  const clearFilters = () => {
    search("");
    if (channel !== "all") onChannelChange?.("all");
    searchRef.current?.focus();
  };
  const sortedSessions = selected ? [...selected.sessions].sort((a, b) => Date.parse(b.createdAt) - Date.parse(a.createdAt)) : [];
  const transcriptAccent = hexColor(storeColor);
  return /* @__PURE__ */ jsx("div", { className: `bs-conversations ${className}`, children: /* @__PURE__ */ jsxs("div", { className: "bs-conversations__layout", "data-thread-open": threadOpen && !!selected, children: [
    /* @__PURE__ */ jsxs("div", { className: "bs-conversations__inbox", ref: listRef, children: [
      /* @__PURE__ */ jsx("div", { className: "bs-conversations__search", children: /* @__PURE__ */ jsx(TextField, { ref: searchRef, type: "search", size: "sm", startIcon: "search", fullWidth: true, "aria-label": t("shared.chat.search"), placeholder: t("shared.chat.search"), value: query, onChange: (event) => search(event.target.value) }) }),
      /* @__PURE__ */ jsxs("div", { className: "bs-conversations__filters", children: [
        channels && /* @__PURE__ */ jsxs(
          Select,
          {
            value: channel,
            onValueChange: (value) => {
              triggerRef.current = null;
              setThreadOpen(false);
              onChannelChange?.(value);
            },
            children: [
              /* @__PURE__ */ jsxs(SelectTrigger, { size: "sm", variant: "subtle", "aria-label": t("shared.chat.filter.channel"), className: "bs-conversations__channel-filter", children: [
                /* @__PURE__ */ jsx(MdChatBubbleOutline, { "aria-hidden": true, className: "bs-conversations__filter-icon" }),
                /* @__PURE__ */ jsx(SelectValue, { placeholder: t("shared.chat.filter.all") })
              ] }),
              /* @__PURE__ */ jsxs(SelectContent, { children: [
                /* @__PURE__ */ jsx(SelectItem, { value: "all", children: t("shared.chat.filter.all") }),
                channels.map((value) => /* @__PURE__ */ jsx(SelectItem, { value, children: channelName(value) }, value))
              ] })
            ]
          }
        ),
        engagedOnly !== void 0 && onEngagedChange && /* @__PURE__ */ jsxs("label", { htmlFor: engagedId, className: "bs-conversations__engaged", children: [
          /* @__PURE__ */ jsx(Switch, { id: engagedId, checked: engagedOnly, onCheckedChange: onEngagedChange, "aria-label": t("shared.chat.filter.engaged"), size: "sm" }),
          t("shared.chat.filter.engaged")
        ] }),
        filterSlot
      ] }),
      /* @__PURE__ */ jsx("div", { className: "bs-conversations__list", "aria-label": t("shared.chat.list_label"), "aria-busy": loading, children: error ? /* @__PURE__ */ jsxs(EmptyState, { variant: "plain", role: "alert", children: [
        /* @__PURE__ */ jsx(EmptyStateMedia, { children: /* @__PURE__ */ jsx(MdErrorOutline, {}) }),
        /* @__PURE__ */ jsx(EmptyStateTitle, { role: "heading", "aria-level": 2, children: error }),
        onRetry && /* @__PURE__ */ jsxs(Fragment, { children: [
          /* @__PURE__ */ jsx(EmptyStateDescription, { children: t("shared.chat.retry_hint") }),
          /* @__PURE__ */ jsx(EmptyStateActions, { children: /* @__PURE__ */ jsxs(Button, { size: "sm", variant: "outlined", color: "neutral", loading, onClick: onRetry, children: [
            /* @__PURE__ */ jsx("span", { className: "buyscout-btn__icon-start", children: /* @__PURE__ */ jsx(MdRefresh, { "aria-hidden": "true" }) }),
            t(loading ? "shared.chat.retrying" : "shared.chat.retry")
          ] }) })
        ] })
      ] }) : loading && !groups.length ? Array.from({ length: lastShown }, (_, i) => /* @__PURE__ */ jsxs("div", { className: "bs-conversations__row bs-conversations__row--placeholder", "aria-hidden": "true", children: [
        /* @__PURE__ */ jsx(Skeleton, { variant: "circle", width: 40, height: 40 }),
        /* @__PURE__ */ jsxs("span", { className: "bs-conversations__summary", children: [
          /* @__PURE__ */ jsx("span", { className: "bs-conversations__row-title", children: /* @__PURE__ */ jsx(Skeleton, { width: ROW_TITLE_WIDTHS[i % ROW_TITLE_WIDTHS.length] }) }),
          /* @__PURE__ */ jsx("span", { className: "bs-conversations__meta", children: /* @__PURE__ */ jsx(Skeleton, { width: ROW_META_WIDTHS[i % ROW_META_WIDTHS.length] }) })
        ] })
      ] }, i)) : groups.length ? groups.map((group) => {
        const groupKey = conversationKey(group);
        const sessions = [...group.sessions].sort((a, b) => Date.parse(b.createdAt) - Date.parse(a.createdAt));
        const latest = sessions[0];
        const email = conversationChannel(group) === "email";
        return /* @__PURE__ */ jsxs(
          "button",
          {
            type: "button",
            className: "bs-conversations__row",
            "aria-current": groupKey === key ? "true" : void 0,
            onClick: (event) => {
              triggerRef.current = event.currentTarget;
              setSelectedKey(groupKey);
              setThreadOpen(true);
            },
            children: [
              /* @__PURE__ */ jsx("span", { className: "bs-conversations__avatar", children: /* @__PURE__ */ jsx(ChannelBrandIcon, { channel: conversationChannel(group), size: 40, shape: "circle" }) }),
              /* @__PURE__ */ jsxs("span", { className: "bs-conversations__summary", children: [
                /* @__PURE__ */ jsxs("span", { className: "bs-conversations__row-head", children: [
                  /* @__PURE__ */ jsx("span", { className: "bs-conversations__row-title", dir: "auto", children: conversationName(group, anonymous) }),
                  "smsOptedOut" in group && group.smsOptedOut === true && /* @__PURE__ */ jsx(Badge, { size: "sm", color: "warning", className: "bs-conversations__opted-out", children: t("shared.chat.opted_out") })
                ] }),
                email ? /* @__PURE__ */ jsx("span", { className: "bs-conversations__subject", dir: "auto", children: latest?.subject || t("shared.chat.email.untitled") }) : /* @__PURE__ */ jsxs("span", { className: "bs-conversations__meta", children: [
                  t("shared.chat.content.session_count", { count: group.sessionCount }),
                  " \xB7 ",
                  stamped(group.lastActivityAt ?? latest?.createdAt, false, (date) => t("shared.chat.content.last_active", { date }))
                ] })
              ] }),
              /* @__PURE__ */ jsx("span", { className: "bs-conversations__count", "aria-hidden": "true", children: group.sessionCount })
            ]
          },
          groupKey
        );
      }) : filtered ? /* @__PURE__ */ jsxs(EmptyState, { variant: "plain", children: [
        /* @__PURE__ */ jsx(EmptyStateDescription, { children: t("shared.chat.empty_filtered") }),
        /* @__PURE__ */ jsx(EmptyStateActions, { children: /* @__PURE__ */ jsx(Button, { size: "sm", variant: "outlined", color: "neutral", onClick: clearFilters, children: t("shared.chat.clear_filters") }) })
      ] }) : /* @__PURE__ */ jsx(EmptyState, { variant: "plain", children: /* @__PURE__ */ jsx(EmptyStateDescription, { children: t("shared.chat.empty_state") }) }) }),
      pagination && pagination.total > 0 && /* @__PURE__ */ jsxs("div", { className: "bs-conversations__footer", children: [
        loading ? /* @__PURE__ */ jsx("span", { className: "bs-conversations__range", children: /* @__PURE__ */ jsx(Skeleton, { inline: true, width: "9em" }) }) : /* @__PURE__ */ jsx("span", { className: "bs-conversations__range", children: t("shared.chat.pagination.summary", { shown: groups.length.toLocaleString(locale), total: pagination.total.toLocaleString(locale) }) }),
        pagination.pageCount > 1 && /* @__PURE__ */ jsx(Pagination, { "aria-label": t("shared.chat.pagination.label"), labels: { previous: t("shared.chat.pagination.previous"), next: t("shared.chat.pagination.next"), page: (page) => t("shared.chat.pagination.page", { page }) }, className: "bs-conversations__pagination", page: pagination.page, pageCount: pagination.pageCount, disabled: loading, onPageChange: (page) => onFetchChatSessions?.({ page, per: pagination.per }) })
      ] })
    ] }),
    /* @__PURE__ */ jsxs("div", { className: "bs-conversations__reader", children: [
      /* @__PURE__ */ jsxs(Button, { ref: backRef, size: "sm", variant: "borderless", color: "neutral", className: "bs-conversations__back", onClick: () => setThreadOpen(false), children: [
        /* @__PURE__ */ jsx("span", { className: "buyscout-btn__icon-start", children: /* @__PURE__ */ jsx(MdChevronLeft, { "aria-hidden": true }) }),
        t("shared.chat.back_to_inbox")
      ] }),
      selected ? /* @__PURE__ */ jsxs(Fragment, { children: [
        /* @__PURE__ */ jsxs("header", { className: "bs-conversations__header", children: [
          /* @__PURE__ */ jsxs("div", { children: [
            /* @__PURE__ */ jsx("h2", { children: /* @__PURE__ */ jsx("span", { dir: "auto", children: getUserHref && userId ? /* @__PURE__ */ jsx(UserLink, { href: getUserHref(userId), children: name }) : name }) }),
            /* @__PURE__ */ jsxs("span", { className: "bs-conversations__meta", children: [
              channelName(selectedChannel ?? ""),
              " \xB7 ",
              selectedChannel === "email" ? t("shared.chat.content.thread_count", { count: selected.sessionCount }) : t("shared.chat.content.session_count", { count: selected.sessionCount }),
              selectedChannel !== "email" && /* @__PURE__ */ jsxs(Fragment, { children: [
                " \xB7 ",
                t("shared.chat.content.message_count", { count: messageCount })
              ] })
            ] }),
            smsOptedOut && /* @__PURE__ */ jsx(Badge, { size: "sm", color: "warning", className: "bs-conversations__opted-out", children: t("shared.chat.opted_out") })
          ] }),
          usage?.totalTokens !== void 0 && /* @__PURE__ */ jsx(Tooltip, { title: tokenUsageText(usage, t, locale), children: /* @__PURE__ */ jsx(Button, { size: "sm", variant: "borderless", color: "neutral", children: tokens(usage.totalTokens) }) })
        ] }),
        /* @__PURE__ */ jsx("div", { className: "bs-conversations__scroll-frame", children: /* @__PURE__ */ jsx("div", { ref: readerScrollRef, className: "bs-conversations__sessions", children: sortedSessions.map((session, index) => {
          const sessionUsage = showTokenUsage ? totalTokenUsage({ ...selected, sessions: [session] }) : void 0;
          const domain = customDomain || "customDomain" in session && session.customDomain || storeID || ("shopifyStoreID" in session && session.shopifyStoreID || "storeID" in session && session.storeID) || void 0;
          const showSessionHeading = selectedChannel !== "email" || sortedSessions.length > 1 || showGroupSessionId || canDelete;
          const accent = hexColor(session.storeColor) ?? transcriptAccent;
          return /* @__PURE__ */ jsxs(
            "section",
            {
              ref: (element) => {
                if (element) sessionRefs.current.set(session.id, element);
                else sessionRefs.current.delete(session.id);
              },
              className: "bs-conversations__session",
              "data-session-id": session.id,
              "data-highlighted": !!highlightedSessionId && session.id.includes(highlightedSessionId),
              "data-store-color": accent ? "" : void 0,
              style: accent ? storeAccentStyle(accent) : void 0,
              children: [
                showSessionHeading && /* @__PURE__ */ jsxs("div", { className: "bs-conversations__session-heading", children: [
                  /* @__PURE__ */ jsxs("div", { children: [
                    /* @__PURE__ */ jsxs("strong", { children: [
                      t(selectedChannel === "email" ? "shared.chat.content.thread_number" : "shared.chat.content.session_number", { number: selected.sessionCount - index }),
                      showGroupSessionId && /* @__PURE__ */ jsxs("span", { className: "bs-conversations__session-id", children: [
                        " (",
                        session.id,
                        ")"
                      ] }),
                      selectedChannel !== "email" && /* @__PURE__ */ jsxs(Fragment, { children: [
                        " \xB7 ",
                        t("shared.chat.content.message_count", { count: session.chatMessage.length })
                      ] })
                    ] }),
                    /* @__PURE__ */ jsx("span", { className: "bs-conversations__meta", children: stamped(session.createdAt, true, (date) => t("shared.chat.content.session_started", { date })) }),
                    selected.retainedHistory && /* @__PURE__ */ jsx("span", { className: "bs-conversations__meta", children: t("shared.chat.content.recent_messages_only") }),
                    "customerEmail" in session && session.customerEmail && /* @__PURE__ */ jsx("span", { className: "bs-conversations__meta", children: t("shared.chat.content.customer_email", { email: session.customerEmail }) }),
                    "customerID" in session && session.customerID && /* @__PURE__ */ jsx("span", { className: "bs-conversations__meta", children: t("shared.chat.content.customer_id", { id: session.customerID }) })
                  ] }),
                  (sessionUsage?.totalTokens !== void 0 || canDelete) && /* @__PURE__ */ jsxs("div", { className: "bs-conversations__session-actions", children: [
                    sessionUsage?.totalTokens !== void 0 && /* @__PURE__ */ jsx(Tooltip, { title: tokenUsageText(sessionUsage, t, locale), children: /* @__PURE__ */ jsx(Button, { size: "sm", variant: "borderless", color: "neutral", children: tokens(sessionUsage.totalTokens) }) }),
                    canDelete && onDeleteSession && /* @__PURE__ */ jsx(Button, { size: "sm", variant: "tinted", color: "error", "aria-label": t("shared.chat.content.delete_session"), onClick: () => onDeleteSession(session.id), children: t("shared.chat.content.delete") })
                  ] })
                ] }),
                !showSessionHeading && selected.retainedHistory && /* @__PURE__ */ jsx("p", { className: "bs-conversations__retention", children: t("shared.chat.content.recent_messages_only") }),
                selectedChannel === "email" ? /* @__PURE__ */ jsx(EmailThread, { session, name, storeAvatarUrl }, session.id) : /* @__PURE__ */ jsx("div", { className: "bs-conversations__session-log", children: /* @__PURE__ */ jsx(ConversationMessages, { activeChatSession: session, loading, showTokenUsage, storeDomain: storeOrigin(domain), onToolClick }) }),
                renderSessionExtra?.(session.id, selectedChannel ?? "")
              ]
            },
            session.id
          );
        }) }, key) }),
        canReply && replyId && onSendChannelMessage && /* @__PURE__ */ jsx(ConversationComposer, { draft: drafts[draftKey] ?? createComposerDraft(), onDraftChange: (update) => setDrafts((current) => ({ ...current, [draftKey]: typeof update === "function" ? update(current[draftKey] ?? createComposerDraft()) : update })), emailReply: selectedChannel === "email" ? { recipient: replyAddress, subject: replySession?.subject, showSubject: selected.sessionCount > 1 } : void 0, aiPaused: "aiPaused" in selected && selected.aiPaused === true, blockedNotice: smsOptedOut ? t("shared.chat.reply.opted_out") : void 0, onSend: (text, ids) => onSendChannelMessage(replyId, text, ids), onResumeAi: capabilities?.resumeAi && onResumeAi ? () => onResumeAi(replyId) : void 0, attachmentPolicy: capabilities?.attachmentPolicy, onUploadAttachment: capabilities?.attachmentPolicy && onUploadChannelAttachment ? (file) => onUploadChannelAttachment(replyId, file) : void 0 }, draftKey)
      ] }) : /* @__PURE__ */ jsx(EmptyState, { variant: "plain", className: "bs-conversations__placeholder", "aria-busy": loading || void 0, children: loading ? /* @__PURE__ */ jsx(Skeleton, { width: "16em" }) : /* @__PURE__ */ jsx(EmptyStateDescription, { role: "status", children: t("shared.chat.empty_prompt") }) })
    ] })
  ] }) });
}
Conversations.displayName = "Conversations";
export {
  Conversations
};
//# sourceMappingURL=Conversations.mjs.map